import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-request-history',
    templateUrl: './request-history.component.html',
    styleUrls: ['./request-history.component.scss']
})
export class RequestHistoryComponent implements OnInit {

    tabs = [
        {
            link: 'toolRequest',
            label: 'admin.request-history.header.requests'
        },
        {
            link: 'toolReturn',
            label: 'admin.request-history.header.returns'
        },
    ]

    constructor() {
    }

    ngOnInit() {
    }

}
